module.exports = __webpack_public_path__ + "static/media/igorc.231f066d.jpg";